import { AxiosResponse, Method } from 'axios';
import { isEmpty } from 'lodash';

import { parseJSON, SendRequest } from '@edirect/request';
import { authService, TokenSetType } from '../auth';
import { configService } from '../../../modules/config/services/config.service';
import { GatewayServiceInterface } from '../gateway';

const STATUS_CODE_OK: number[] = [200, 201, 202, 204];

export class GatewayService implements GatewayServiceInterface {
  private readonly baseURL: string;
  private readonly http: SendRequest;

  constructor(baseURL?: string) {
    this.baseURL =
      baseURL ||
      process.env.INSURTECH_GATEWAY_URL ||
      configService.get('INSURTECH_GATEWAY_URL');
    this.http = new SendRequest();
  }

  public async sendRequest<T>(
    method: Method,
    uri: string,
    data?: unknown,
    tokenSet?: TokenSetType,
    headers?: Record<string, unknown>,
  ): Promise<T> {
    if (isEmpty(tokenSet)) {
      tokenSet = await authService.getClientToken();
    }
    const returnAxiosResponseAlways = true;

    return this.http
      .sendRequest<unknown, T>('', {
        baseURL: this.baseURL,
        headers: {
          Authorization: `${tokenSet?.tokenType} ${tokenSet?.accessToken}`,
          ...headers,
        },
      })
      .request(method, uri, data, undefined, returnAxiosResponseAlways)
      .then((response) => {
        const responseAxios = response as AxiosResponse<T>;
        if (!STATUS_CODE_OK.includes(responseAxios.status)) {
          throw responseAxios.data;
        }
        return parseJSON<T>(responseAxios.data);
      });
  }
}

export const gatewayService = new GatewayService();
